import { useEffect, useState } from "react";

export const FilterDropdown = (props) => {
  const [options, setOptions] = useState([]);

  const valueChanged = (value) => {
    props.filter.value = value;

    let newState = { ...props.ficheData };
    props.setFicheData((prev) => {
      return { ...prev, filter: newState.filter };
    });
  };

  useEffect(() => {
    if (props.filter.options) {
      const newoptions = [];

      props.filter.options.forEach((option, index) => {
        newoptions.push(
          <option
            value={
              props.filter?.values[index] ? props.filter.values[index] : option
            }
          >
            {option}
          </option>
        );
      });

      setOptions(newoptions);
    }
  }, [JSON.stringify(props.filter.options)]);

  return (
    <div
      className={`col-sm-${
        props.filter.gridWidth != 0 ? props.filter.gridWidth : 4
      }`}
    >
      <label>
        <strong>{props.filter.title}</strong>
      </label>
      <select
        class="c-input__field c-toggle-label"
        id="field_subject"
        value={props.filter.value ?? ""}
        onChange={(evt) => valueChanged(evt.target.value)}
      >
        <option value={""}>{props.filter.defaultValue}</option>
        {options}
      </select>
    </div>
  );
};
